import PageHeader from "@/components/layout/page-header.jsx";
import CopyUrlClipboard from "@/components/shared/copy-url-clipboard.jsx";

export default function SelfService({
  overlays,
  pageName,
  pageSubtitle,
  pageDescription = "",
  headerTitle = "General Overlays",
  children = null,
}) {
  return (
    <div className="max-w-full relative flex flex-col items-center">
      <div className={`hero w-full pt-0 overflow-x-hidden`}>
        <div className="hero-content mx-6 pt-5 max-w-full w-full overflow-x-hidden flex-col items-start">
          <div>
            <PageHeader
              description={pageDescription}
              subtitle={pageSubtitle}
              name={pageName}
              links={[
                {
                  title: pageName,
                },
              ]}
            />
          </div>

          <div className="overflow-x-hidden w-full mb-4 p-2">
            <h2 className="text-xl mb-2 ml-0.5" id="overlays">
              {headerTitle}
            </h2>
            <div className="join join-vertical rounded-xl mb-2 w-full">
              {overlays.map((overlay) => (
                <div
                  key={overlay.id}
                  className="collapse outline-none collapse-arrow join-item border-base-300 border"
                >
                  <input type="radio" name={`gcx-accordion`} />
                  <div id={overlay.id} className="collapse-title text-lg font-semibold">
                    {overlay.name}
                  </div>
                  <div className="collapse-content">
                    {overlay.customize !== undefined && overlay.customize}

                    {overlay.description !== undefined && (
                      <p className="text-sm mb-5">{overlay.description}</p>
                    )}

                    <CopyUrlClipboard
                      disabled={overlay.disableCopy}
                      showCopyDemoModeLinkButton={!!overlay.demoModeURL}
                      overlayURL={overlay.url}
                      overlayDemoModeURL={overlay.demoModeURL}
                    />

                    {overlay.width && overlay.height && (
                      <div className="mt-2">
                        <span className="select-none">Width: </span>
                        <strong>{overlay.width}</strong> <br />
                        <span className="select-none">Height: </span>
                        <strong>{overlay.height}</strong>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
